module.exports = __webpack_public_path__ + "static/media/joan_sabria2.99ea4bac.jpg";